import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import showPoint from './Point';

Vue.use(ElementUI);
Vue.prototype.$bus = new Vue();
Vue.prototype.$point = showPoint;
export default Vue;



// WEBPACK FOOTER //
// ./src/utils/Vue.js